import { createSelector } from 'reselect';

const selectAuthCache = (state: any) => state.login;

export const selectAuthError = createSelector(
  selectAuthCache,
  (cache: any) => cache.error
);

export const selectOTPConfig = createSelector(
  selectAuthCache,
  (cache: any) => cache.isOTPActivated
);

export const selectIsLoginSubmitting = createSelector(
  selectAuthCache,
  (cache: any) => cache.submitting
);
